import React from 'react';
import { Checkbox, Fieldset } from '@fourthwall/components';
import { TimezonedDatePicker } from '@modules/Timezone/components/TimezonedDatePicker';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
import * as S from './styled';
export const TimeLimit = () => {
    const { form, isLoading } = useTierContext();
    if (form.values.discountType !== 'oneTime')
        return null;
    if (form.values.price && parseFloat(form.values.price) === 0)
        return null;
    if (!form.values.discount)
        return null;
    const renderLimitInput = () => {
        if (!form.values.timeLimit)
            return null;
        return (React.createElement(Fieldset.Row, { inner: true },
            React.createElement(TimezonedDatePicker, { type: "range", value: [form.values.startDate, form.values.endDate], error: form.errors.startDate || form.errors.endDate, showTimeInputs: true, placement: "top", disabled: isLoading, onChange: ([startDate, endDate]) => {
                    form.setFieldValue(FormFields.startDate, startDate);
                    form.setFieldValue(FormFields.endDate, endDate);
                } })));
    };
    return (React.createElement(Fieldset.Row, { inner: true },
        React.createElement(S.Container, null,
            React.createElement(Checkbox, { label: "Make this offer time-limited", disabled: isLoading, ...form.getFieldProps(FormFields.timeLimit) }),
            renderLimitInput())));
};
